
import {ActionTypes,  CCAxios} from './../../cc-imports'


const SponsorsActions = {
    getSponsorsByUserId: (userId, type)=> {
        return {
            type: ActionTypes.GET_SPONSORS,
            payload: CCAxios.get('/sponsor/userId/' + userId + '/'),
            meta : {
                type : type,
                id : userId
            }
        }
    },
};

export default SponsorsActions



// WEBPACK FOOTER //
// ./src/app/data/actions/SponsorsActions.js